import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, generatePath } from "react-router-dom";

// import logo from "../assets/img/logo.png";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Header from "./Header";
import { useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import Toaster from "./common/Toaster";
// import QrScanner from "../components/common/Html5QrcodeScannerComponent";
import Capture from "./Capture";
// import MiniCapture from "./MiniCapture";
import ConfirmationPopup from "./common/ConfirmationPopup";
import BasicInformationSection from "./SurveyComponenrs/BasicInformationSection";
import PhyMeasurementsSection from "./SurveyComponenrs/PhyMeasurementsSection";
import ComplianceSection from "./SurveyComponenrs/ComplianceSection";

// import Loader from "./common/Loader";
import {
  GET_PROPERTY_INFO_WITH_MASTER,
  GENERATEQRCODE_API,
  SAVE_SURVEY_FORM_DATA,
  //UPLOAD_IMAGE_API,
  DELETE_IMAGE_API,
  GET_NEXT_REF_NUMBER,
  GET_FLOORPLAN_IMAGE,
  GET_AI_SUGGESTION,
  SEND_FEEDBACK_TO_AI,
  PROPERTY_DASHBOARD_API,
} from "../api/apiPath";
import http from "../api/server";
import { hostName } from "../config/config";

import {
  COMPLIANCE_CHECK,
  FORM_DATA,
  BASE_MEASURES,
  BASE_MEASURES_COMP,
  ACTION_MENU_FLAG,
  ACTION_MENU_IMAGES,
  AI_KEY_VALUES,
  AI_REMEDY_OPTIONS,
} from "./common/constant";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
// import dayjs from "dayjs";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useParams();
  const { clientNameParam, propertyMasterId, inspectionRefnumber } = location;
  const [qrCode, setQrCode] = useState("");
  const [doorOtherFlag, setDoorOtherFlag] = useState(false);
  const [doorColorOtherFlag, setDoorColorOtherFlag] = useState(false);
  const [doorMaterialOtherFlag, setDoorMaterialOtherFlag] = useState(false);
  const [isGlazing, setIsGlazing] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isColdSeals, setIsColdSeals] = useState(false);
  const [isFireKeepLocked, setFireKeepLocked] = useState(false);
  const [isHoldOpenVisible, setIsHoldopenVisible] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [complianceCheck, setComplianceCheck] = useState(COMPLIANCE_CHECK);
  const [validationFlag, setValidationFlag] = useState(false);
  const [actionmenuFlag, setActionMenuFlag] = useState([]);
  const [actionImages, setActionImages] = useState(ACTION_MENU_IMAGES);
  const [error, setError] = useState(null);
  const [ShowScanQRCode, setShowScanQRCode] = useState(false);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [doorTypesOption, setDoorTypesOption] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [isFloorFromAPI, setIsFloorFromAPI] = useState(false);

  const [resetCaptureFlag, setResetCaptureFlag] = useState(false);
  const [formData, setFormData] = useState(FORM_DATA);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });

  const [basicFormData, setBasicFormData] = useState({
    clientId: "",
    buildingName: "",
    uniqueRef: "",
    date: new Date().toISOString().split("T")[0],
    location: "",
    floor: null,
    comment: "",
    floorPlan: [],
  });
  const [aiSuggestionData, setAiSuggestionData] = useState(AI_KEY_VALUES);
  const [showAiSuggestionModal, setShowAiSuggestionModal] = useState({
    show: false,
    title: "",
    heading: "",
    desctription: "",
    severity: "",
    dueDate: "",
    remedyOptions: [],
    confScore: "",
    rejectReason: "",
    category:"",
  });
  const [selectedRemediation, setSelectedRemediation] =
    useState(AI_REMEDY_OPTIONS);
  const [rejectionReason, setRejectionReason] = useState(false);
  const [isAIIntegrated, setIsAIIntegrated] = useState(false);

  const mandatoryFieldRef = useRef({});

  useEffect(() => {
    setIsloading(true);
    setIsFloorFromAPI(false);

    if (propertyMasterId !== undefined && propertyMasterId !== null) {
      const fetchData = async () => {
        await fetchPropertyData();
        setTimeout(() => {
          handleFormReset();
        }, 100);
      };
      fetchData();

      let obj = ACTION_MENU_FLAG;
      // for (let key in BASE_MEASURES) {
      //   if (formData[key] < BASE_MEASURES[key]) {
      //     obj[key] = true;
      //   } else {
      //     obj[key] = false;
      //   }
      // }

      for (let key in BASE_MEASURES_COMP) {
        if (key === "pyroGlazing") {
          obj[key] = false;
        } else {
          if (complianceCheck[key] != BASE_MEASURES_COMP[key]) {
            obj[key] = true;
          } else {
            obj[key] = false;
          }
        }
      }
      setActionMenuFlag(obj);
    }
  }, []);

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const fetchPropertyData = async () => {
    try {
      const response = await http.get(
        GET_PROPERTY_INFO_WITH_MASTER +
          propertyMasterId +
          "?InspectionReferenceNumber=" +
          inspectionRefnumber
      );
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const response1 = await http.get(
        GET_NEXT_REF_NUMBER + propertyMasterId + "/" + userObj.userId
      );
      if (response1.data == "Property user mapping not found") {
        throw new Error(
          "You don't have an assigned property. Please contact admin"
        );
      }
      if (!response1.status) {
        throw new Error(`HTTP error! status: ${response1?.status}`);
      }
      let NextRefNumber = await response1.data.nextRefNumber;
      const dataResponse = await response?.data;
      setDoorTypesOption(dataResponse.doorTypes);
      setBasicFormData({
        ...basicFormData,
        clientId: dataResponse.propertyMaster.clientId,
        buildingName: dataResponse.propertyMaster.propertyName,
        uniqueRef: dataResponse.propertyMaster.uniqueRefNo,
        location: dataResponse.propertyMaster.propertyLocation,
      });
      setFormData({
        ...formData,
        buildingName: dataResponse.propertyMaster.propertyName,
        uniqueRef: dataResponse.propertyMaster.uniqueRefNo,
        location: dataResponse.propertyMaster.propertyLocation,
        doorNumber: await CreateDoorReference(
          dataResponse.propertyMaster.propertyName,
          NextRefNumber
        ),
      });
      //check is AI integrated in summary by client
      const summaryResponse = await http.get(
        PROPERTY_DASHBOARD_API +
          "clientId=" +
          dataResponse.propertyMaster.clientId +
          "&userId=" +
          userObj.userId
      );
      if (!summaryResponse.status) {
        throw new Error(`HTTP error! status: ${response?.message}`);
      } else if (summaryResponse.status === 200) {
        const getProperty = summaryResponse?.data?.propertyFields.filter(
          (x) => x.propertyMasterId === propertyMasterId
        );
        if (getProperty.length > 0) {
          setIsAIIntegrated(getProperty[0].isAIIntegrationEnabled);
        }
      }
      setIsloading(false);
      return dataResponse;
    } catch (error) {
      setError(error?.data);
      setIsloading(false);
      return {};
    }
  };
  const CreateDoorReference = async (propertyName, nextRefNumber) => {
    let doorRefNumber = "";
    if (propertyName != undefined && propertyName != null) {
      doorRefNumber =
        userObj?.userName
          ?.split(" ")
          ?.filter((word) => word)
          ?.map((word) => word[0].toUpperCase())
          ?.join("") +
        "-" +
        propertyName
          ?.split(" ")
          ?.filter((word) => word)
          ?.map((word) => word[0].toUpperCase())
          ?.join("") +
        "-DRN-" +
        String(nextRefNumber).padStart(4, "0");
    }
    return doorRefNumber;
  };
  const base64ToFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const extnsion = mime.split("/")[1];
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], `${filename}.${extnsion}`, { type: mime });
  };

  const uploadImageAPI = async (newImages, field) => {
    const latestImage = newImages[newImages.length - 1];
    const file = base64ToFile(latestImage, `${field}_Image_${Date.now()}`);
    const formDataToUpload = new FormData();
    formDataToUpload.append("File", file);
    formDataToUpload.append("Client", basicFormData.clientId); // Use actual values from state/context if needed
    formDataToUpload.append("Property", basicFormData.buildingName);
    formDataToUpload.append("InspectionDate", new Date().toISOString());
    try {
      const response = await fetch(hostName + "/api/Inspection/upload", {
        method: "POST",
        body: formDataToUpload,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      // const response = await http.post(UPLOAD_IMAGE_API,
      //    formDataToUpload,
      //    {headers: {"Content-Type": "multipart/form-data"}})
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const dataResponse = await response?.json();
      return dataResponse?.result.blobUrl;
    } catch (error) {
      setError(error?.data);
      return {};
    }
  };

  const deleteImageAPI = async (imageToDelete) => {
    try {
      const response = await http.delete(DELETE_IMAGE_API + imageToDelete);
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
    } catch (error) {
      setError(error?.data);
    }
  };
  const handleDeleteImages = (indexToRemove, field) => {
    let imageToDelete = "";
    if (field === "Additional") {
      imageToDelete = floorPlanImages[indexToRemove];
      const combined = floorPlanImages?.filter(
        (_, index) => index !== indexToRemove
      );
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      mandatoryFieldRef.current.doorFile.value = "";
      imageToDelete = formData.doorPhotos[indexToRemove];
      const imgArr = formData.doorPhotos;
      const combined = imgArr?.filter((_, index) => index !== indexToRemove);
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      mandatoryFieldRef.current.floorFile.value = "";
      imageToDelete = basicFormData.floorPlan[indexToRemove];
      const imgArr = basicFormData.floorPlan;
      const combined = imgArr?.filter((_, index) => index !== indexToRemove);
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    } else {
      const imgArr = actionImages[field];
      imageToDelete = imgArr[indexToRemove];
      const combined = imgArr?.filter((_, index) => index !== indexToRemove);
      setActionImages({
        ...actionImages,
        [field]: combined,
      });
    }
    if (field === "Floor") {
      if (!isFloorFromAPI) {
        deleteImageAPI(imageToDelete);
      }
    } else {
      deleteImageAPI(imageToDelete);
    }
  };

  const handleComplianceToggle = (e) => {
    if (e.target.name === "selfClosingDevice") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          selfClosingDevice: e.target.checked,
        };
      });
      setFireKeepLocked(!e.target.checked);
    } else if (e.target.name === "fireLockedSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireLockedSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireLockedSign: !e.target.checked,
      });
      if (e.target.checked === false) {
        getAiSuggestion("COMPLIANCE", "fireLockedSign", "no");
      }
    } else if (e.target.name === "fireShutSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireShutSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireShutSign: !e.target.checked,
      });
      if (e.target.checked === false) {
        getAiSuggestion("COMPLIANCE", "fireShutSign", "no");
      }
      setIsHoldopenVisible(!e.target.checked);
    } else {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          [e.target.name]: e.target.checked,
        };
      });
      if (
        BASE_MEASURES_COMP[e.target.name] != undefined &&
        e.target.checked != BASE_MEASURES_COMP[e.target.name]
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
        if (
          e.target.name != "damageToDoor" &&
          e.target.name != "visualDefectsToDoor"
        ) {
          getAiSuggestion("COMPLIANCE", e.target.name, "no");
        }
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }

    if (e.target.name === "doorGlazing") {
      if (e.target.checked === true) {
        setIsGlazing(true);
        if (complianceCheck.pyroGlazing != BASE_MEASURES_COMP.pyroGlazing) {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: true,
          });
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: false,
          });
        }
      } else {
        setIsGlazing(false);
        setActionMenuFlag({
          ...actionmenuFlag,
          pyroGlazing: false,
        });
      }
    }
  };

  const resetIndvidualField = (field) => {
    if (field === "glazingDoorLabel") {
      const glazingArr = [
        "glazingDoorLabel0",
        "glazingDoorLabel1",
        "glazingDoorLabel2",
        "glazingDoorLabel3",
      ];
      glazingArr.forEach((elem) => {
        mandatoryFieldRef.current[elem].style.border = "2px solid #ccc";
      });
    } else {
      mandatoryFieldRef.current[field] != null
        ? (mandatoryFieldRef.current[field].style.border = "1px solid #dee2e6")
        : null;
    }
  };

  const resetMandatoryFields = () => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorOther",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "head",
        "hingeLocation",
        "noOfhinges",
        "hinge",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        // "floorFile",
        "doorFile",
        "fireResistance",
        "hingesFireRatedRating",
      ];
    } else {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "head",
        "hingeLocation",
        "hinge",
        "noOfHinges",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        // "floorFile",
        "doorFile",
        "fireResistance",
        "hingesFireRatedRating",
      ];
    }
    if (doorColorOtherFlag) {
      newArr = [...newArr, "doorColorOther"];
    }
    if (doorMaterialOtherFlag) {
      newArr = [...newArr, "doorMaterialOther"];
    }
    newArr.forEach((elem) => {
      mandatoryFieldRef?.current[elem] != null
        ? (mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6")
        : null;
    });

    // mandatoryFieldRef?.current?.floorFile != null
    //   ? (mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6")
    //   : null;
    mandatoryFieldRef?.current?.doorFile != null
      ? (mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6")
      : null;
  };

  const handleMandatoryFields = () => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorOther",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "head",
        "hingeLocation",
        "hinge",
        "noOfHinges",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        "fireResistance",
      ];
    } else {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "head",
        "hingeLocation",
        "hinge",
        "noOfHinges",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorSize",
        "fullDoorsetSize",
        "fireResistance",
      ];
    }
    if (doorColorOtherFlag) {
      newArr = [...newArr, "doorColorOther"];
    }
    if (doorMaterialOtherFlag) {
      newArr = [...newArr, "doorMaterialOther"];
    }
    newArr.forEach((elem) => {
      const test = mandatoryFieldRef?.current[elem];
      if (
        test != undefined &&
        (!test?.value?.trim() || test?.value === "Select")
      ) {
        mandatoryFieldRef.current[elem].style.border = "2px solid red";
      } else {
        mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6";
      }
      if (elem === "noOfHinges") {
        test?.value <= 1
          ? (mandatoryFieldRef.current[elem].style.border = "2px solid red")
          : (mandatoryFieldRef.current[elem].style.border =
              "1px solid #dee2e6");
      }
    });
    for (let key in ACTION_MENU_FLAG) {
      if (actionmenuFlag[key] === true) {
        const tempArr = [
          "Severity",
          "Category",
          "DueDate",
          "Remediation",
          "DamageType",
        ];
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef?.current[key + elem];
          if (test != undefined) {
            if (!test?.value.trim() || test?.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      } else if (key === "hingesFireRated" && actionmenuFlag[key] === false) {
        const tempArr = ["Rating"];
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef?.current[key + elem];
          if (test != undefined) {
            if (!test?.value.trim() || test?.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      }
    }
    const glazingArr = [
      "glazingDoorLabel0",
      "glazingDoorLabel1",
      "glazingDoorLabel2",
      "glazingDoorLabel3",
    ];
    if (mandatoryFieldRef.current.GlazingDoor?.value === "Yes") {
      if (formData.glazingDoorLabel === "") {
        glazingArr.forEach((elem) => {
          mandatoryFieldRef.current[elem].style.border = "2px solid red";
        });
      } else {
        glazingArr.forEach((elem) => {
          mandatoryFieldRef.current[elem].style.border = "2px solid #ccc";
        });
      }
    }
    if (
      mandatoryFieldRef?.current?.doorFile != undefined ||
      mandatoryFieldRef.current.doorFile != null
    ) {
      if (formData.doorPhotos.length === 0) {
        mandatoryFieldRef.current.doorFile.style.border = "2px solid red";
      } else {
        mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
      }
    }
  };

  const handleValidationOnSave = (status) => {
    setIsloading(true);
    let validFlag1 = false;
    let validFlag2 = false;
    let validFlag3 = false;
    let validFlag4 = false;
    for (let key in BASE_MEASURES) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        validFlag1 = true;
        break;
      } else if (
        actionmenuFlag[key] === true &&
        (formData[key + "Severity"] === "Select" ||
          formData[key + "Category"] === "Select" ||
          formData[key + "Remediation"] === "" ||
          formData[key + "DueDate"] === "")
      ) {
        validFlag1 = true;
        break;
      } else if (key === "hinge" && formData.hingeLocation === "Select") {
        validFlag1 = true;
        break;
      } else if (key === "noOfHinges" && formData[key] <= 1) {
        validFlag1 = true;
        break;
      } else {
        validFlag1 = false;
      }
    }
    let checkArr = { doorType: "doorType", doorPhotos: "doorPhotos" };
    for (let key in checkArr) {
      if (key === "doorPhotos" && formData[key].length === 0) {
        validFlag2 = true;
        break;
      } else if (key === "doorType") {
        if (
          formData[key] === "4" &&
          (formData.doorOther === "" ||
            formData.doorOther === null ||
            formData.doorOther === undefined)
        ) {
          validFlag2 = true;
          break;
        } else if (formData[key] === "Select") {
          validFlag2 = true;
          break;
        }
      } else {
        validFlag2 = false;
      }
    }
    for (let key in BASE_MEASURES_COMP) {
      if (key === "pyroGlazing" && complianceCheck.doorGlazing === true) {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "")
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      } else if (key === "coldSmokeSeals") {
        if (isColdSeals) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "")
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "fireLockedSign") {
        if (isFireKeepLocked) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "")
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "holdOpenDevice") {
        if (isHoldOpenVisible) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "")
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "visualDefectsToDoor") {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            complianceCheck[key + "DamageType"] === "Select")
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      } else if (key === "hingeFireRated") {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            complianceCheck[key + "DamageType"] === "Select")
        ) {
          validFlag3 = true;
          break;
        } else if (
          actionmenuFlag[key] === false &&
          complianceCheck[key + "Rating"] === "Select"
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      } else {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "")
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      }
    }
    let phyArr = {
      doorThickness: null,
      frameDepth: null,
      doorSize: null,
      fullDoorsetSize: null,
    };
    for (let key in phyArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        validFlag4 = true;
        break;
      } else {
        validFlag4 = false;
      }
    }
    let validFlag5 = false;
    if (
      // basicFormData.floorPlan.length === 0 ||
      basicFormData.floor === undefined ||
      basicFormData.floor === null ||
      basicFormData.floor === "" ||
      formData.fireResistance === "Select"
    ) {
      validFlag5 = true;
    } else {
      validFlag5 = false;
    }
    //check door location
    let validFlag6;
    if (
      formData.doorLocation === "" ||
      formData.doorLocation === undefined ||
      formData.doorLocation === null
    ) {
      validFlag6 = true;
    } else {
      validFlag6 = false;
    }
    let validFlag7;
    let doorArr = {
      doorType: null,
      doorColor: null,
      // doorOther: null,
      // doorColorOther: null,
      doorMaterial: null,
      // doorMaterialOther: null,
      GlazingDoor: null,
      // glazingDoorLabel: null,
      fireResistance: null,
    };
    if (doorOtherFlag) {
      doorArr.doorOther = null;
    }
    if (doorColorOtherFlag) {
      doorArr.doorColorOther = null;
    }
    if (doorMaterialOtherFlag) {
      doorArr.doorMaterialOther = null;
    }
    if (formData.GlazingDoor === "Yes") {
      doorArr.glazingDoorLabel = null;
    }
    for (let key in doorArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined ||
        formData[key] === "Select"
      ) {
        validFlag7 = true;
        break;
      } else {
        validFlag7 = false;
      }
    }
    let validFlag8;
    if (
      actionmenuFlag.hingesFireRated === false &&
      (complianceCheck.hingesFireRatedRating === "Select" ||
        complianceCheck.hingesFireRatedRating === null ||
        complianceCheck.hingesFireRatedRating === "")
    ) {
      validFlag8 = true;
    } else {
      validFlag8 = false;
    }
    if (
      validFlag1 ||
      validFlag2 ||
      validFlag3 ||
      validFlag4 ||
      validFlag5 ||
      validFlag6 ||
      validFlag7 ||
      validFlag8
    ) {
      setValidationFlag(true);
      handleMandatoryFields();
      setIsloading(false);
    } else {
      setValidationFlag(false);
      handleSubmit(status);
    }
  };
  const handleSubmit = async (status) => {
    //Create payload for API

    const phyGaps = ["head", "hinge", "noOfHinges", "closing", "threshold"];
    let newObj = {
      fireRatingID: formData.fireResistance ? formData.fireResistance : "",
      comments: basicFormData.comment,
      hingePosition: formData.hingeLocation,
    };
    phyGaps.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: actionmenuFlag[elem] ? "yes" : "no",
        timeline: "Short term",
        severity: actionmenuFlag[elem]
          ? formData[elem + "Severity"]
            ? formData[elem + "Severity"]
            : ""
          : "",
        comment: actionmenuFlag[elem]
          ? formData[elem + "Comments"]
            ? formData[elem + "Comments"]
            : ""
          : "",
        category: actionmenuFlag[elem]
          ? formData[elem + "Category"]
            ? formData[elem + "Category"]
            : ""
          : "",
        dueDate: actionmenuFlag[elem]
          ? formData[elem + "DueDate"]
            ? formData[elem + "DueDate"]
            : null
          : null,
        remediation: actionmenuFlag[elem]
          ? formData[elem + "Remediation"]
            ? formData[elem + "Remediation"]
            : ""
          : "",
        photos: actionmenuFlag[elem] ? actionImages[elem] : [],
      };
      newObj[elem] = newObj1;
    });
    const phyMeasures = [
      "doorThickness",
      "frameDepth",
      "doorSize",
      "fullDoorsetSize",
    ];
    phyMeasures.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: "no",
        timeline: "",
        severity: "",
        comment: "",
        category: "",
        dueDate: null,
        remediation: "",
        photos: [],
      };
      newObj[elem] = newObj1;
    });

    const compArr = [
      "intumescentStrips",
      "coldSmokeSeals",
      "selfClosingDevice",
      "fireLockedSign",
      "fireShutSign",
      "holdOpenDevice",
      "visibleCertification",
      "doorGlazing",
      "pyroGlazing",
      "doorCloseFully",
      "damageToDoor",
      "visualDefectsToDoor",
      "hingesFireRated",
    ];
    let newArr = [];
    compArr.forEach((item) => {
      if (item === "fireLockedSign") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          isCompliant: complianceCheck[item],
          actionItem: !isFireKeepLocked
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType: "",
                fireRating: "",
              },
        };
        newArr.push(newObj2);
      } else if (item === "holdOpenDevice") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          isCompliant: complianceCheck[item],
          actionItem: !isHoldOpenVisible
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType: "",
                fireRating: "",
              },
        };
        newArr.push(newObj2);
      } else if (item === "damageToDoor" || item === "visualDefectsToDoor") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          isCompliant: complianceCheck[item],
          actionItem: !complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType:
                  item === "visualDefectsToDoor"
                    ? complianceCheck[item + "DamageType"]
                    : "",
                fireRating: "",
              },
        };
        newArr.push(newObj2);
      } else {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          isCompliant: complianceCheck[item],
          actionItem: complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating:
                  item === "hingesFireRated"
                    ? complianceCheck[item + "Rating"]
                    : "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType:
                  item === "visualDefectsToDoor"
                    ? complianceCheck[item + "DamageType"]
                    : "",
                fireRating: "",
              },
        };
        newArr.push(newObj2);
      }
    });

    let doorImgObj = {};
    for (let key = 1; key <= formData.doorPhotos.length; key++) {
      let name = "Image " + key + " Path";
      doorImgObj[name] = formData.doorPhotos[key - 1];
    }

    if (propertyMasterId !== undefined && propertyMasterId !== null) {
      const fullFormData = {
        propertyInfo: {
          propertyMasterId: propertyMasterId,
          inspectionStartedOn: basicFormData.date,
          inspectedBy: userObj.userEmail,
          InspectedById: userObj.userId,
          inspectionApprovedDate: null,
          lastInspectionDate: new Date().toISOString(),
          inspectionApprovedBy: "",
          lastInspectedBy: userObj.userEmail,
          status: status,
          inspectionUpdatedBy: userObj.userEmail,
          inspectionUpdatedOn: new Date().toISOString(),
          nextInspectionDueDate: null,
          InspectionReferenceNumber: inspectionRefnumber,
        },
        inspectedPropertyFloorsInfo: {
          floorNo:
            basicFormData.floor != undefined
              ? Number(basicFormData.floor)
              : null,
          floorPlanImage: basicFormData.floorPlan
            ? basicFormData.floorPlan[0]
            : "no image",
          createdBy: userObj?.userEmail,
          updatedBy: userObj?.userEmail,
        },
        inspectedDoorDto: {
          floorNo:
            basicFormData.floor != undefined
              ? Number(basicFormData.floor)
              : null,
          floorImage: basicFormData.floorPlan
            ? basicFormData.floorPlan[0]
            : "no image",
          doorTypeId: formData.doorType ? formData.doorType : "",
          doorRefNumber: formData.doorNumber ? formData.doorNumber : "",
          doorNumber: formData.doorNumber ? formData.doorNumber : "",
          inspectedBy: userObj.userEmail,
          doorInspectionDate: basicFormData.date,
          status: "Compliant",
          flatName: "Flat A",
          doorTypeName: formData.doorTypeName ? formData.doorTypeName : "",
          propertyName: basicFormData.buildingName
            ? basicFormData.buildingName
            : "",
          otherDoorTypeName: formData.doorOther,
          doorLocation: formData.doorLocation,
          doorPhoto: doorImgObj,
          doorColor: doorColorOtherFlag
            ? formData.doorColor + "-" + formData.doorColorOther
            : formData.doorColor,
          doorMaterial: doorMaterialOtherFlag
            ? formData.doorMaterial + "-" + formData.doorMaterialOther
            : formData.doorMaterial,
          doorGlaze:
            formData.GlazingDoor === "Yes" ? formData.glazingDoorLabel : "No",
        },
        complianceChecks: newArr,
        physicalMeasurement: newObj,
        additionalInfos: [
          {
            imagePath: floorPlanImages,
          },
        ],
      };

      // Submit formData to API
      const response = await saveData(JSON.stringify(fullFormData));
      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "Your inspection for Door reference Number: " +
            formData.doorNumber +
            " has been saved successfully.",
        });
        setTimeout(() => loadNewForm(), 3000);
      } else {
        setIsloading(false);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again",
        });
      }
    }
  };

  const saveData = async (allData) => {
    try {
      const response = await http.post(SAVE_SURVEY_FORM_DATA, allData);
      return response;
    } catch (error) {
      return error;
    }
  };

  const loadNewForm = async () => {
    setIsloading(true);
    await fetchPropertyData();
    await handleFormReset();
    setTimeout(
      () =>
        setToastData({
          toastShow: true,
          toastString:
            "Survey is now refreshed for new door. Please continue for new next door.",
          toastType: "success",
        }),
      500
    );
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; }
            .print-container { text-align: center; }
            .modal-header { background-color: gray; color: white; padding: 10px; }
          </style>
        </head>
        <body>
          <div class="print-container" style="margin-top:100px">
            <img src="${qrCode}" alt="QR Code" height='400px' width='400px' />
            <h3>Door Reference Number: ${formData.doorNumber}</h3>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };
  const handleBuildingName = (e) => {
    setFormData({ ...formData, buildingName: e.target.value });
  };
  const handleFormDataChange = (e) => {
    resetIndvidualField(e.target.name);
    if (e.target.name === "doorType") {
      const doorTypeName = e.target.options[e.target.selectedIndex].text;
      setFormData({
        ...formData,
        doorTypeName: doorTypeName,
        [e.target.name]: e.target.value,
      });
      if (doorTypeName === "Other") {
        setDoorOtherFlag(true);
      } else {
        setDoorOtherFlag(false);
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    if (e.target.name === "doorColor") {
      e.target.value === "Other"
        ? setDoorColorOtherFlag(true)
        : setDoorColorOtherFlag(false);
    }
    if (e.target.name === "doorMaterial") {
      e.target.value === "Other"
        ? setDoorMaterialOtherFlag(true)
        : setDoorMaterialOtherFlag(false);
    }
  };

  const handleCancel = () => {
    navigate(
      generatePath("/client/:clientNameParam/property-form", {
        clientNameParam,
      })
    );
  };
  const handleFireResistanceChange = (e) => {
    resetIndvidualField("fireResistance");
    setFormData({
      ...formData,
      fireResistance: e.target.value,
    });
    if (!e.target.value.includes("S")) {
      //e.target.value === "FD30"
      if (
        formData.threshold != null &&
        formData.threshold != "" &&
        formData.threshold > 8
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: true,
        });
        getAiSuggestion("PHYSICAL", "threshold", formData.threshold);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: false,
        });
      }
    } else {
      if (
        formData.threshold != null &&
        formData.threshold != "" &&
        formData.threshold > BASE_MEASURES.threshold
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: true,
        });
        getAiSuggestion("PHYSICAL", "threshold", formData.threshold);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: false,
        });
      }
    }
    if (
      e.target.value === "FD30S" ||
      e.target.value === "FD60S" ||
      e.target.value === "FD90S"
    ) {
      setIsColdSeals(true);
    } else {
      setIsColdSeals(false);
    }
  };

  const handleGapsChange = (e) => {
    resetIndvidualField(e.target.name);
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "threshold") {
      if (!formData.fireResistance.includes("S")) {
        //formData.fireResistance === "FD30"
        if (e.target.value > 8) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
          getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      } else {
        if (e.target.value > BASE_MEASURES[e.target.name]) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
          getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      }
    } else if (e.target.name === "noOfHinges") {
      if (e.target.value && e.target.value < BASE_MEASURES[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    } else {
      if (e.target.value > BASE_MEASURES[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
        getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }
  };

  const getSeverityDate = (sev) => {
    switch (sev.target.value) {
      case "1":
        return new Date().toISOString().split("T")[0];
      case "2":
        return new Date(new Date().setDate(new Date().getDate() + 30))
          .toISOString()
          .split("T")[0];
      case "3":
        return new Date(new Date().setDate(new Date().getDate() + 90))
          .toISOString()
          .split("T")[0];
      case "4":
        return new Date(new Date().setDate(new Date().getDate() + 180))
          .toISOString()
          .split("T")[0];
      default:
        return new Date().toISOString().split("T")[0];
    }
  };

  const handleActionFieldsChange = (e, field, section) => {
    let name = e.target.name + field;
    resetIndvidualField(name);
    let value;
    let severityDueDate = "";
    if (field === "Severity") {
      severityDueDate = getSeverityDate(e);
      resetIndvidualField(e.target.name + "DueDate");
    }
    if (field === "Comments") {
      value = removeSpecialCharacters(e.target.value);
    } else {
      value = e.target.value;
    }
    if (field === "Category") {
      if (e.target.value === "5") {
        if (section === "PHYSICAL") {
          setFormData({
            ...formData,
            [name]: value,
            [e.target.name + "Remediation"]:
              "Remediation - Fire Door Replacement required",
          });
        } else if (section === "COMPLIANCE") {
          setComplianceCheck({
            ...complianceCheck,
            [name]: value,
            [e.target.name + "Remediation"]:
              "Remediation - Fire Door Replacement required",
          });
        }
      } else {
        if (section === "PHYSICAL") {
          setFormData({
            ...formData,
            [name]: value,
            [e.target.name + "Remediation"]:
              formData[e.target.name + "Remediation"] ===
              "Remediation - Fire Door Replacement required"
                ? ""
                : formData[e.target.name + "Remediation"],
          });
        } else if (section === "COMPLIANCE") {
          setComplianceCheck({
            ...complianceCheck,
            [name]: value,
            [e.target.name + "Remediation"]:
              complianceCheck[e.target.name + "Remediation"] ===
              "Remediation - Fire Door Replacement required"
                ? ""
                : complianceCheck[e.target.name + "Remediation"],
          });
        }
      }
    } else {
      if (section === "PHYSICAL") {
        field === "Severity"
          ? setFormData({
              ...formData,
              [name]: value,
              [e.target.name + "DueDate"]: severityDueDate,
            })
          : setFormData({
              ...formData,
              [name]: value,
            });
      } else if (section === "COMPLIANCE") {
        field === "Severity"
          ? setComplianceCheck({
              ...complianceCheck,
              [name]: value,
              [e.target.name + "DueDate"]: severityDueDate,
            })
          : field === "Rating"
          ? setComplianceCheck({
              ...complianceCheck,
              [e.target.name + "Rating"]: value,
            })
          : setComplianceCheck({
              ...complianceCheck,
              [name]: value,
            });
      }
    }
  };
  const handleResetAction = (field, section) => {
    const Nme = [field] + "Timeline";
    const nme1 = [field] + "Severity";
    const nme2 = [field] + "Comments";
    const nme3 = [field] + "Category";
    const nme4 = [field] + "DueDate";
    const nme5 = [field] + "Remediation";
    const nme6 = [field] + "DamageType";
    if (section === "PHYSICAL") {
      setFormData({
        ...formData,
        [Nme]: "Select",
        [nme1]: "Select",
        [nme2]: "",
        [nme3]: "Select",
        [nme4]: "",
        [nme5]: "",
      });
    } else if (section === "COMPLIANCE") {
      setComplianceCheck({
        ...complianceCheck,
        [Nme]: "Select",
        [nme1]: "Select",
        [nme2]: "",
        [nme3]: "Select",
        [nme4]: "",
        [nme5]: "",
        [nme6]: "Select",
      });
    }
  };

  const getFloorImage = async (floor) => {
    if (floor != "") {
      try {
        const response = await http.get(
          GET_FLOORPLAN_IMAGE +
            "propertyMasterID=" +
            propertyMasterId +
            "&floorNo=" +
            floor
        );
        if (!response.status) {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
        const tempImage = response?.data;
        tempImage === "" ? setIsFloorFromAPI(false) : setIsFloorFromAPI(true);
        setBasicFormData({
          ...basicFormData,
          floor: floor,
          floorPlan: tempImage === "" ? [] : [tempImage],
        });
        tempImage === ""
          ? (mandatoryFieldRef.current.floorFile.value = "")
          : (mandatoryFieldRef.current.floorFile.value = "Saved Floor Plan");
        resetIndvidualField("floorFile");
      } catch (error) {
        setError(error?.data);
        return {};
      }
    } else {
      setBasicFormData({
        ...basicFormData,
        floorPlan: [],
        floor: floor,
      });
      mandatoryFieldRef.current.floorFile.value = "";
    }
  };

  const [floorPlanImages, setFloorPlanImages] = useState([]);

  const handleChange = async (e) => {
    if (e.target.name === "floor") {
      resetIndvidualField(e.target.name);
      const { name, value } = e.target;
      setBasicFormData({
        ...basicFormData,
        [name]: value,
      });
      setTimeout(() => getFloorImage(value), 100);
    } else if (e.target.name === "comment") {
      let val = removeSpecialCharacters(e.target.value);
      setBasicFormData({ ...basicFormData, comment: val });
    } else {
      const { name, value } = e.target;
      setBasicFormData({ ...basicFormData, [name]: value });
    }
  };

  const handleImagesChange = async (newImages, field) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }
    if (field === "Additional") {
      const combined = [...floorPlanImages, ...newArr];
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
      const imgArr = formData.doorPhotos;
      const combined = [...imgArr, ...newArr];
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      mandatoryFieldRef.current.floorFile.style.border = "1px solid #dee2e6";
      const imgArr = basicFormData.floorPlan;
      const combined = [...imgArr, ...newArr];
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    }
  };

  const handleImagesChangeMini = async (newImages, field) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }
    const imgArr = actionImages[field];
    const combined = [...imgArr, ...newArr];
    setActionImages({
      ...actionImages,
      [field]: combined,
    }); // No limit now
  };

  const generateQRCode = async () => {
    try {
      setShowModal(true);
      setShowLoader(true);
      let data =
        window.location.origin +
        "/client/" +
        clientNameParam +
        "/editSurvey/" +
        propertyMasterId +
        "/" +
        formData.doorNumber +
        "/" +
        inspectionRefnumber;
      const qrCodeUrl = await http.get(GENERATEQRCODE_API + data);
      setQrCode(qrCodeUrl.data.qrCode);
      setShowLoader(false);
    } catch (error) {
      throw new Error(`HTTP error! status: ${error}`);
    } finally {
      setShowLoader(false);
    }
    setShowModal(true);
  };

  const removeSpecialCharacters = (input) => {
    return input.replace(/[^a-zA-Z0-9 !?.,"'() & :; -]/g, ""); // Keeps letters, numbers, and spaces
  };

  const handleFormReset = () => {
    setFormData((prev) => ({
      ...prev,

      // General
      doorLocation: "",
      doorType: "1",
      doorColor: "Select",
      doorColorOther: "",
      doorMaterial: "Select",
      doorMaterialOther: "",
      GlazingDoor: "Select",
      doorOther: "",
      doorPhotos: [],
      fireResistance: "Select",

      // PHYSICAL MEASUREMENTS - GAPS
      head: "",
      headTimeline: "Select",
      headSeverity: "Select",
      headComments: "",
      headCategory: "Select",
      headDueDate: "",
      headRemediation: "",

      hinge: "",
      hingeLocation: "Select",
      noOfHinges: "",
      noOfHingesTimeline: "Select",
      noOfHingesSeverity: "Select",
      noOfHingesComments: "",
      noOfHingesCategory: "Select",
      noOfHingesDueDate: "",
      noOfHingesRemediation: "",
      hingeTimeline: "Select",
      hingeSeverity: "Select",
      hingeComments: "",
      hingeCategory: "Select",
      hingeDueDate: "",
      hingeRemediation: "",

      closing: "",
      closingTimeline: "Select",
      closingSeverity: "Select",
      closingComments: "",
      closingCategory: "Select",
      closingDueDate: "",
      closingRemediation: "",

      threshold: "",
      thresholdTimeline: "Select",
      thresholdSeverity: "Select",
      thresholdComments: "",
      thresholdCategory: "Select",
      thresholdDueDate: "",
      thresholdRemediation: "",

      doorThickness: "",
      frameDepth: "",
      doorSize: "",
      fullDoorsetSize: "",
    }));

    // Basic info reset
    setBasicFormData((prev) => ({
      ...prev,
      date: new Date().toISOString().split("T")[0],
      floor: "",
      comment: "",
      floorPlan: [],
    }));

    // Other resets
    setFloorPlanImages([]);

    setComplianceCheck((prev) => ({
      ...prev,
      intumescentStrips: true,
      intumescentStripsTimeline: "Select",
      intumescentStripsSeverity: "Select",
      intumescentStripsComments: "",
      intumescentStripsCategory: "Select",
      intumescentStripsDueDate: "",
      intumescentStripsRemediation: "",
      coldSmokeSeals: true,
      coldSmokeSealsTimeline: "Select",
      coldSmokeSealsSeverity: "Select",
      coldSmokeSealsComments: "",
      coldSmokeSealsCategory: "Select",
      coldSmokeSealsDueDate: "",
      coldSmokeSealsRemediation: "",
      selfClosingDevice: true,
      selfClosingDeviceTimeline: "Select",
      selfClosingDeviceSeverity: "Select",
      selfClosingDeviceComments: "",
      selfClosingDeviceCategory: "Select",
      selfClosingDeviceDueDate: "",
      selfClosingDeviceRemediation: "",
      fireLockedSign: true,
      fireLockedSignTimeline: "Select",
      fireLockedSignSeverity: "Select",
      fireLockedSignComments: "",
      fireLockedSignCategory: "Select",
      fireLockedSignDueDate: "",
      fireLockedSignRemediation: "",
      fireShutSign: true,
      fireShutSignTimeline: "Select",
      fireShutSignSeverity: "Select",
      fireShutSignComments: "",
      fireShutSignCategory: "Select",
      fireShutSignDueDate: "",
      fireShutSignRemediation: "",
      holdOpenDevice: true,
      visibleCertification: true,
      doorGlazing: true,
      pyroGlazing: true,
      pyroGlazingTimeline: "Select",
      pyroGlazingSeverity: "Select",
      pyroGlazingComments: "",
      pyroGlazingCategory: "Select",
      pyroGlazingDueDate: "",
      pyroGlazingRemediation: "",
      doorCloseFully: true,
      doorCloseFullyTimeline: "Select",
      doorCloseFullySeverity: "Select",
      doorCloseFullyComments: "",
      doorCloseFullyCategory: "Select",
      doorCloseFullyDueDate: "",
      doorCloseFullyRemediation: "",
      damageToDoor: false,
      damageToDoorTimeline: "Select",
      damageToDoorSeverity: "Select",
      damageToDoorComments: "",
      damageToDoorCategory: "Select",
      damageToDoorDueDate: "",
      damageToDoorRemediation: "",
      visualDefectsToDoor: false,
      visualDefectsToDoorTimeline: "Select",
      visualDefectsToDoorSeverity: "Select",
      visualDefectsToDoorComments: "",
      visualDefectsToDoorCategory: "Select",
      visualDefectsToDoorDueDate: "",
      visualDefectsToDoorRemediation: "",
      visualDefectsToDoorDamageType: "Select",
      hingesFireRated: true,
      hingesFireRatedTimeline: "Select",
      hingesFireRatedSeverity: "Select",
      hingesFireRatedComments: "",
      hingesFireRatedCategory: "Select",
      hingesFireRatedDueDate: "",
      hingesFireRatedRemediation: "",
      hingesFireRatedRating: "Select",
    }));
    setActionMenuFlag((prev) => ({
      ...prev,
      head: false,
      hinge: false,
      closing: false,
      threshold: false,
      noOfHinges: false,
      intumescentStrips: false,
      coldSmokeSeals: false,
      selfClosingDevice: false,
      fireLockedSign: false,
      fireShutSign: false,
      pyroGlazing: false,
      doorCloseFully: false,
      damageToDoor: false,
      visualDefectsToDoor: false,
      hingesFireRated: false,
    }));
    setActionImages((prev) => ({
      ...prev,
      head: [],
      hinge: [],
      closing: [],
      threshold: [],
      noOfHinges: [],
      intumescentStrips: [],
      coldSmokeSeals: [],
      selfClosingDevice: [],
      fireLockedSign: [],
      fireShutSign: [],
      pyroGlazing: [],
      doorCloseFully: [],
      damageToDoor: [],
      visualDefectsToDoor: [],
      hingesFireRated: [],
    }));
    setDoorOtherFlag(false);
    setDoorColorOtherFlag(false);
    setDoorMaterialOtherFlag(false);
    // complianceCheck.doorGlazing ? setIsGlazing(true) : setIsGlazing(false);
    setValidationFlag(false);
    setIsColdSeals(false);
    setFireKeepLocked(false);
    setIsGlazing(true);
    setIsHoldopenVisible(false);

    // MiniCapture reset flag
    setResetCaptureFlag(true);
    setTimeout(() => setResetCaptureFlag(false), 100);
    //red highlights reset
    setTimeout(() => resetMandatoryFields(), 100);
  };

  const getAiSuggestion = async (type, name, value) => {
    if (isAIIntegrated) {
      setIsloading(true);
      try {
        const payload = {
          email: userObj?.userEmail,
          inspectionReferenceNumber: inspectionRefnumber,
          doorReferenceNumber: formData?.doorNumber,
          measurementType: aiSuggestionData[name + "Title"],
          value: value,
          unit: aiSuggestionData[name + "Unit"],
          apiKey: "claude_key",
          aiProvider: "claude",
        };
        const response = await http.post(GET_AI_SUGGESTION, payload);
        if (response.status === 200) {
          const ai_data = JSON.parse(response?.data?.response);
          const ref = response?.data?.referenceNum;
          console.log(ref, ai_data);
          setAiSuggestionData({
            ...aiSuggestionData,
            [name + "Action"]: ai_data?.actionItems[0],
            [name + "RefNo"]: ref,
            [name + "Type"]: type,
          });
          const seveValue =
            ai_data?.actionItems[0]?.severity.charAt(0).toUpperCase() +
            ai_data?.actionItems[0]?.severity.slice(1).toLowerCase();
          setShowAiSuggestionModal({
            show: true,
            heading: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(),
            title: name,
            desctription: ai_data?.actionItems[0]?.actionDescription,
            severity: seveValue,
            category: ai_data?.actionItems[0]?.category,
            dueDate: ai_data?.actionItems[0]?.dueDate,
            remedyOptions: ai_data?.actionItems[0]?.remediationOptions,
            confScore: ai_data?.actionItems[0]?.confidenceScore,
            rejectReason: "",
          });
          setIsloading(false);
        }
      } catch (error) {
        console.log(error);
        setIsloading(false);
      }
    }
  };

  const handleRejectAISuggest = async (title, reject) => {
    setShowAiSuggestionModal({
      show: false,
      title: "",
      heading: "",
      desctription: "",
      severity: "",
      dueDate: "",
      remedyOptions: [],
      confScore: "",
      category:"",
      rejectReason: "",
    });
    setRejectionReason(false);
    setSelectedRemediation({
      ...selectedRemediation,
      [title]: null,
    });
    try {
      const payload = {
        refNo: aiSuggestionData[title + "RefNo"],
        rejectedComment: reject,
        isAccept: false,
        acceptedResponse: "",
      };
      const response = await http.post(SEND_FEEDBACK_TO_AI, payload);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAcceptAISuggest = async (title) => {
    setShowAiSuggestionModal({
      show: false,
      title: "",
      heading: "",
      desctription: "",
      severity: "",
      dueDate: "",
      remedyOptions: [],
      confScore: "",
      category:"",
    });
    setRejectionReason(false);
    let selectedReme = selectedRemediation;
    const severityValues = [
      { option: "critical", value: "1" },
      { option: "high", value: "2" },
      { option: "medium", value: "3" },
      { option: "low", value: "4" },
    ];
    const categoryValues = [
      { option: "Firedoor Repair", value: "1" },
      { option: "Signage repair", value: "2" },
      { option: "Fire door Replacement", value: "3" },
      { option: "Testing, Records, Log Book", value: "4" },
      { option: "Door Replacement required", value: "5"},
      { option: "Door Repair", value: "6"}
    ];
    const actionitemSelected = aiSuggestionData[title + "Action"];
    const formattedSev = severityValues.filter(
      (x) =>
        x.option.toLowerCase() === actionitemSelected.severity.toLowerCase()
    )[0].value;
    const tempCategory = categoryValues.filter(x => x.option.toLowerCase() === actionitemSelected.category.toLowerCase())[0].value;
    //const formattedSev = actionitemSelected.severity.charAt(0).toUpperCase() + actionitemSelected.severity.slice(1).toLowerCase();
    // Split and reorder to ISO format
    const [day, month, year] = actionitemSelected.dueDate.split("/");
    const isoDate = `${year}-${month}-${day}`;

    // Now safely parse
    const formDate = new Date(isoDate).toISOString().split("T")[0];
    const remedyOption =
      actionitemSelected.remediationOptions[selectedReme[title]];
    const type = aiSuggestionData[title + "Type"];
    if (type === "PHYSICAL") {
      setFormData({
        ...formData,
        [title + "Severity"]: formattedSev,
        [title + "DueDate"]: formDate,
        [title + "Category"]: tempCategory,
        [title + "Remediation"]:
          remedyOption.option.replace(/^Option\s\d+:\s*/, "") +
          ": " +
          remedyOption.plan,
      });
    } else if (type === "COMPLIANCE") {
      setComplianceCheck({
        ...complianceCheck,
        [title + "Severity"]: formattedSev,
        [title + "DueDate"]: formDate,
        [title + "Category"]: tempCategory,
        [title + "Remediation"]:
          remedyOption.option.replace(/^Option\s\d+:\s*/, "") +
          ": " +
          remedyOption.plan,
      });
    }
    setSelectedRemediation({
      ...selectedRemediation,
      [title]: null,
    });
    try {
      // const params = new URLSearchParams();
      // params.append("RefNo", aiSuggestionData[title + "RefNo"]);
      // params.append("IsAccept", true);
      // const query = params.toString();
      const payload = {
        refNo: aiSuggestionData[title + "RefNo"],
        rejectedComment: "",
        isAccept: true,
        acceptedResponse: remedyOption.option,
      };
      const response = await http.post(SEND_FEEDBACK_TO_AI, payload);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const { userObj } = useSelector((state) => state.user);
  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          <ConfirmationPopup
            show={showConfirmationPopup.show}
            headingText={showConfirmationPopup.headingText}
            infoText={showConfirmationPopup.infoText}
            cancelText={showConfirmationPopup.cancelText}
            submitText={showConfirmationPopup.submittext}
            onCancel={() => {
              setShowConfirmationPopup({
                ...showConfirmationPopup,
                show: false,
                headingText: "",
                infoText: "",
                cancelText: "",
                submittext: "",
              });
            }}
            onSubmit={() => {
              setShowConfirmationPopup({
                ...showConfirmationPopup,
                show: false,
                headingText: "",
                infoText: "",
                cancelText: "",
                submittext: "",
              });
              handleValidationOnSave("In Progress");
            }}
          />
          {/* <Loader active={isLoading} /> */}
          <LoadingComponent loading={isLoading} />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          {showModal && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "60%" }}
              >
                <span className="close" onClick={() => setShowModal(false)}>
                  &times;
                </span>
                <h6 className="modal-header">
                  {formData.buildingName} / {formData.doorNumber}
                </h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  {showLoader ? (
                    <div
                      className="approvalLoader"
                      style={{ marginLeft: "45%" }}
                    ></div>
                  ) : (
                    qrCode && (
                      <img
                        src={qrCode}
                        alt="QR Code"
                        style={{ height: "80%", width: "50%" }}
                      />
                    )
                  )}
                  {!showLoader && (
                    <div style={{ marginTop: "20px" }}>
                      <button
                        className="btn btn-primary"
                        style={{ minHeight: "20px" }}
                        onClick={handlePrint}
                      >
                        Print
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {showAiSuggestionModal.show && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "70%" }}
              >
                {/* <span
                  className="close"
                  onClick={() => setShowAiSuggestionModal(false)}
                >
                  &times;
                </span> */}
                <h6 className="modal-header">
                  AI Based Suggestion - Action item for{" "}
                  {showAiSuggestionModal.heading}
                </h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="px-2 py-1">
                    <div className="d-flex flex-row justify-content-between">
                      <p className="ai-header">Action Description:</p>{" "}
                      <p className="ai-header-confidence">
                        Confidence Score:{" "}
                        <span
                          style={
                            Number(showAiSuggestionModal.confScore) >= 90
                              ? { color: "#00A600" }
                              : { color: "#CB8300" }
                          }
                        >
                          {showAiSuggestionModal.confScore}%
                        </span>
                      </p>
                    </div>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.desctription}
                    </p>
                    <p className="ai-header">Severity:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.severity}
                    </p>
                    <p className="ai-header">Due Date:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.dueDate}
                    </p>
                    <p className="ai-header">Category:</p>
                    <p className="ai-paragraph">{showAiSuggestionModal?.category}</p>
                    <p className="ai-header">Remediation Options:</p>
                    <RadioGroup
                      className="mt-2"
                      column
                      aria-labelledby="Remediation options"
                      value={
                        selectedRemediation[showAiSuggestionModal.title] || ""
                      }
                      onChange={(e) => {
                        const optionVal = e.target.value;
                        console.log(optionVal);
                        setSelectedRemediation({
                          ...selectedRemediation,
                          [showAiSuggestionModal.title]: optionVal,
                        });
                      }}
                    >
                      {showAiSuggestionModal?.remedyOptions?.map(
                        (item, index) => {
                          return (
                            <FormControlLabel
                              key={index}
                              className="radio-box mb-2 p-2"
                              value={index}
                              control={<Radio size="small" />}
                              label={
                                <div className="d-flex flex-column align-items-start">
                                  <span>
                                    {item?.option.replace(
                                      /^Option\s\d+:\s*/,
                                      ""
                                    )}
                                  </span>
                                  <span className="text-start">
                                    {item?.plan}
                                  </span>
                                </div>
                              }
                            />
                          );
                        }
                      )}
                    </RadioGroup>
                    <div className="ai-disclaimer">
                      <p className="mb-0">
                        <i className="bi bi-exclamation-triangle text-danger"></i>{" "}
                        AI Disclaimer
                      </p>
                      <p>
                        The results displayed above are generated using
                        Artificial Intelligence (AI) and may not always be fully
                        accurate or complete. AI-generated results are for
                        <strong> guidance only</strong> and may not reflect full
                        inspection accuracy.{" "}
                        <strong>
                          Please verify all findings manually before taking
                          compliance action.
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-1">
                    <button
                      className="btn btn-secondary"
                      style={{ minHeight: "20px" }}
                      onClick={() => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          show: false,
                        });
                        setRejectionReason(true);
                      }}
                    >
                      Reject
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{ minHeight: "20px" }}
                      disabled={
                        selectedRemediation[showAiSuggestionModal.title] ===
                        null
                      }
                      onClick={() =>
                        handleAcceptAISuggest(showAiSuggestionModal.title)
                      }
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {rejectionReason && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "60%" }}
              >
                {/* <span className="close" onClick={() => setShowModal(false)}>
                  &times;
                </span> */}
                <h6 className="modal-header">Reject AI Based Suggestion</h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="px-2 py-1">
                    <p className="ai-paragraph">
                      If you believe the AI analysis needs correction, please
                      share your feedback below.
                    </p>
                    <textarea
                      className="form-control"
                      rows="4"
                      style={{ minHeight: "auto", height: "auto" }}
                      placeholder=""
                      value={showAiSuggestionModal.rejectReason}
                      onChange={(e) => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          rejectReason: e.target.value,
                        });
                      }}
                      id="floatingTextarea"
                    ></textarea>
                  </div>
                  <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-1">
                    <button
                      className="btn btn-secondary"
                      style={{ minHeight: "20px" }}
                      onClick={() => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          show: true,
                        });
                        setRejectionReason(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{ minHeight: "20px" }}
                      disabled={showAiSuggestionModal.rejectReason === ""}
                      onClick={() =>
                        handleRejectAISuggest(
                          showAiSuggestionModal.title,
                          showAiSuggestionModal.rejectReason
                        )
                      }
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="d-flex dashboard_body flex-column py-3 ">
            <form className="row m-0">
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <BasicInformationSection
                  mandatoryFieldRef={mandatoryFieldRef}
                  basicFormData={basicFormData}
                  handleChange={handleChange}
                  handleBuildingName={handleBuildingName}
                  isView={false}
                  formData={formData}
                  handleImagesChange={handleImagesChange}
                  handleDeleteImages={handleDeleteImages}
                  resetCaptureFlag={resetCaptureFlag}
                  handleFormDataChange={handleFormDataChange}
                  doorTypesOption={doorTypesOption}
                  doorOtherFlag={doorOtherFlag}
                  ShowScanQRCode={ShowScanQRCode}
                  generateQRCode={generateQRCode}
                  OnsetShowScanQRCode={setShowScanQRCode}
                  doorColorOtherFlag={doorColorOtherFlag}
                  doorMaterialOtherFlag={doorMaterialOtherFlag}
                />
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">
                        Fire Rating and certification
                        <span style={{ color: "red" }}>*</span>
                      </p>
                    </div>
                    <div className="form-floating">
                      <select
                        ref={(el) =>
                          (mandatoryFieldRef.current.fireResistance = el)
                        }
                        className="form-select"
                        name="fireResistance"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={formData.fireResistance}
                        onChange={handleFireResistanceChange}
                      >
                        <option selected>Select</option>
                        <option value="FD30">FD30</option>
                        <option value="FD60">FD60</option>
                        <option value="FD90">FD90</option>
                        <option value="FD120">FD120</option>
                        <option value="FD30S">FD30S</option>
                        <option value="FD60S">FD60S</option>
                        <option value="FD90S">FD90S</option>
                        <option value="FD120S">FD120S</option>
                      </select>
                      <label htmlFor="floatingSelect">
                        Fire Resistance<span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <PhyMeasurementsSection
                    isRequestForChange={false}
                    isApprover={false}
                    isAppprovalPending={false}
                    handleApproverComments={() => {}}
                    handleApproverCheckbox={() => {}}
                    approverComments={[]}
                    approverCheckbox={[]}
                    formData={formData}
                    mandatoryFieldRef={mandatoryFieldRef}
                    handleDeleteImages={handleDeleteImages}
                    resetCaptureFlag={resetCaptureFlag}
                    handleFormDataChange={handleFormDataChange}
                    isView={false}
                    handleGapsChange={handleGapsChange}
                    actionmenuFlag={actionmenuFlag}
                    actionImages={actionImages}
                    handleImagesChangeMini={handleImagesChangeMini}
                    handleResetAction={handleResetAction}
                    handleActionFieldsChange={handleActionFieldsChange}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-lg-4 mb-3">
                <div className="card mb-4">
                  <ComplianceSection
                    isRequestForChange={false}
                    isApprover={false}
                    isAppprovalPending={false}
                    handleApproverComments={() => {}}
                    handleApproverCheckbox={() => {}}
                    approverComments={[]}
                    approverCheckbox={[]}
                    mandatoryFieldRef={mandatoryFieldRef}
                    complianceCheck={complianceCheck}
                    handleComplianceToggle={handleComplianceToggle}
                    isColdSeals={isColdSeals}
                    isHoldOpenVisible={isHoldOpenVisible}
                    isFireKeepLocked={isFireKeepLocked}
                    isGlazing={isGlazing}
                    handleDeleteImages={handleDeleteImages}
                    resetCaptureFlag={resetCaptureFlag}
                    isView={false}
                    actionmenuFlag={actionmenuFlag}
                    actionImages={actionImages}
                    handleImagesChangeMini={handleImagesChangeMini}
                    handleResetAction={handleResetAction}
                    handleActionFieldsChange={handleActionFieldsChange}
                  />
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Photos</p>
                    </div>
                    <div className="form-floating">
                      <div className="col-sm-12 mb-3">
                        <div className="d-flex gap-3 flex-wrap">
                          <Capture
                            onImagesChange={(images) =>
                              handleImagesChange(images, "Additional")
                            }
                            onImageDelete={(index) =>
                              handleDeleteImages(index, "Additional")
                            }
                            reset={resetCaptureFlag}
                            mandatoryFieldRef={mandatoryFieldRef}
                            fieldValue={"additionalFile"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Comments</p>
                    </div>
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        rows="5"
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Comments"
                        // value="Comments"
                        id="floatingTextarea"
                        name="comment"
                        value={basicFormData.comment}
                        onChange={(e) => handleChange(e)}
                      ></textarea>
                      <label htmlFor="floatingTextarea">Comments</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mb-3">
                <div className="card">
                  {validationFlag && (
                    <span style={{ color: "red" }}>
                      Please fill all required fields
                    </span>
                  )}
                  <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                    <button
                      type="button"
                      className="btn btn-tertiary"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => handleFormReset()}
                    >
                      Reset
                    </button>
                    <button
                      type="button"
                      disabled={isLoading}
                      className="btn btn-primary"
                      onClick={() =>
                        setShowConfirmationPopup({
                          ...showConfirmationPopup,
                          show: true,
                          headingText: "Save and Proceed",
                          infoText:
                            "Please make sure you have filled all correct details, once submitted, you may not be able to edit the details",
                          cancelText: "Cancel",
                          submittext: "Submit",
                        })
                      }
                    >
                      Save & Proceed
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <Footer />
            <div className="bottom-bar-spacing"></div>
            <BottomBarIcons />
          </div>
        </div>
      )}
    </>
  );
};
export default Dashboard;
